var map = {
	"./kudos_1.svg": 106,
	"./kudos_10.svg": 107,
	"./kudos_11.svg": 108,
	"./kudos_12.svg": 109,
	"./kudos_13.svg": 110,
	"./kudos_14.svg": 111,
	"./kudos_15.svg": 112,
	"./kudos_16.svg": 113,
	"./kudos_17.svg": 114,
	"./kudos_18.svg": 115,
	"./kudos_19.svg": 116,
	"./kudos_2.svg": 117,
	"./kudos_20.svg": 118,
	"./kudos_21.svg": 119,
	"./kudos_22.svg": 120,
	"./kudos_23.svg": 121,
	"./kudos_24.svg": 122,
	"./kudos_25.svg": 123,
	"./kudos_26.svg": 124,
	"./kudos_27.svg": 125,
	"./kudos_28.svg": 126,
	"./kudos_29.svg": 127,
	"./kudos_3.svg": 128,
	"./kudos_30.svg": 129,
	"./kudos_31.svg": 130,
	"./kudos_32.svg": 131,
	"./kudos_33.svg": 132,
	"./kudos_34.svg": 133,
	"./kudos_35.svg": 134,
	"./kudos_36.svg": 135,
	"./kudos_37.svg": 136,
	"./kudos_38.svg": 137,
	"./kudos_39.svg": 138,
	"./kudos_4.svg": 139,
	"./kudos_40.svg": 140,
	"./kudos_41.svg": 141,
	"./kudos_42.svg": 142,
	"./kudos_43.svg": 143,
	"./kudos_44.svg": 144,
	"./kudos_45.svg": 145,
	"./kudos_46.svg": 146,
	"./kudos_47.svg": 147,
	"./kudos_48.svg": 148,
	"./kudos_49.svg": 149,
	"./kudos_5.svg": 150,
	"./kudos_50.svg": 151,
	"./kudos_51.svg": 152,
	"./kudos_52.svg": 153,
	"./kudos_53.svg": 154,
	"./kudos_54.svg": 155,
	"./kudos_55.svg": 156,
	"./kudos_56.svg": 157,
	"./kudos_57.svg": 158,
	"./kudos_58.svg": 159,
	"./kudos_59.svg": 160,
	"./kudos_6.svg": 161,
	"./kudos_60.svg": 162,
	"./kudos_61.svg": 163,
	"./kudos_62.svg": 164,
	"./kudos_63.svg": 165,
	"./kudos_64.svg": 166,
	"./kudos_65.svg": 167,
	"./kudos_66.svg": 168,
	"./kudos_67.svg": 169,
	"./kudos_68.svg": 170,
	"./kudos_69.svg": 171,
	"./kudos_7.svg": 172,
	"./kudos_70.svg": 173,
	"./kudos_71.svg": 174,
	"./kudos_72.svg": 175,
	"./kudos_73.svg": 176,
	"./kudos_74.svg": 177,
	"./kudos_75.svg": 178,
	"./kudos_76.svg": 179,
	"./kudos_77.svg": 180,
	"./kudos_78.svg": 181,
	"./kudos_79.svg": 182,
	"./kudos_8.svg": 183,
	"./kudos_80.svg": 184,
	"./kudos_81.svg": 185,
	"./kudos_82.svg": 186,
	"./kudos_83.svg": 187,
	"./kudos_84.svg": 188,
	"./kudos_85.svg": 189,
	"./kudos_86.svg": 190,
	"./kudos_87.svg": 191,
	"./kudos_9.svg": 192
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 26;


//////////////////
// WEBPACK FOOTER
// ./src/assets/kudos ^\.\/.*$
// module id = 26
// module chunks = 0